import { Switch, withStyles } from "@material-ui/core";

// The app's on/off switch. MUI's "default" colour leaves the track grey in
// both positions, so on and off look the same at a glance; this one is blue
// when on and grey when off (the same blue as "What Your Team Sees").
const OnSwitch = withStyles({
  switchBase: {
    color: "#F4F5F7",
    "&$checked": { color: "#007BFF" },
    "&$checked + $track": { backgroundColor: "#007BFF", opacity: 0.55 },
  },
  checked: {},
  track: { backgroundColor: "#8A9099", opacity: 0.6 },
})(Switch);

export default OnSwitch;
